export default "__VITE_ASSET__CBQ6JhNp__"